const auth = {
	Authorization: "Authorization",
	Bearer: "Bearer"
};

export const AUTHORIZATION = auth;
